import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyGridHeader from '../components/GridComponents/SurveyGridHeader';
import SurveyGridBody from '../components/GridComponents/SurveyGridBody';
import SurveyGridRow from '../components/GridComponents/SurveyGridRow';
import {
  CommonResponses, ElementType,
  NumberFormat,
  SelectCombos, SelectCombosPABS,
} from '../Enums/constants';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment';


export const PabsPlanDesignTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea pageName="PlanDesign" />
      <SurveyContentContainer>
        <SurveySection
          id="1"
          labelText="Plan Characteristics"
        >
          <SurveyElement
            questionNumber="102"
            labelText="Indicate 'yes' if your employers/member groups can be described as the following (indicate all that apply):"
          />
          <SurveyElement
            questionNumber="102.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="CityOrCountyOnly"
            labelText="Is your membership limited to a city or county?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="ParticipatingLocal"
            labelText="Participating Local Employers (i.e. municipalities have a choice in participating in your plan)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="State"
            labelText="State, Province, Country?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Teachers"
            labelText="Teachers?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="School"
            labelText="School Employees (Custodians, Admin. Staff)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.f"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="PoliceAndFire"
            labelText="Safety (Police, Fire, Sheriff's Dept, etc) ?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.g"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="OtherJudgesLegislators"
            labelText="Other (Judges, Legislators, etc)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.h"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Corporate"
            labelText="Corporate?"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.i"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Industry"
            labelText="Industry? (describe)"
            subQuestion
          />
          <SurveyElement
            questionNumber="102.i.i1"
            inputType={ElementType.TEXTAREA}
            name="IndustryDescr"
            showIf={{Industry: {not: CommonResponses.NO}}}
            doubleSubQuestion
          />
          <SurveyElement
            questionNumber="103"
            labelText="Which of the following descriptions best describes the non-optional benefit plans that you administer for each of your member groups. A plan is non-optional if members must participate in it, or choose between it and alternatives. Do not include membership in benefit plans that are supplemental and optional such as deferred compensation 457, 403B or 401(k) plans. Do not include plans administered by a 3rd party."
          />
          <SurveyElement
            questionNumber="103.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_226aYN"
            labelText="Traditional Defined Benefit (DB)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_226bYN"
            labelText="DB Cash Balance (aka Money Purchase)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_226dYN"
            labelText="Hybrid DB/ DC Cash Balance?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_226cYN"
            labelText="Hybrid DB/ Money Match?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="DROPSavings"
            labelText="DROP savings?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.f"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_226gYN"
            labelText="Defined Contribution (DC)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.g"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="HybridDbDc"
            labelText="Hybrid DB/ DC?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.h"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_226iYN"
            labelText="Other (describe)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="103.h.h1"
            inputType={ElementType.TEXTAREA}
            name="Q_226iDescr"
            showIf={{Q_226iYN: {not: CommonResponses.NO}}}
            doubleSubQuestion
          />
          <SurveyElement
            questionNumber="104"
            labelText="Do members in any of your defined benefit plan(s) have the option of electing:"
            note="These questions are not applicable for DC plans or the DC portion of hybrid DB/DC plans"
          />
          <SurveyElement
            questionNumber="104.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_227"
            labelText="A 'variable investment option' that can increase or decrease the value of a member's future DB pension depending on the investment performance of a 'variable fund'?"
            subQuestion
          />
          <SurveyElement
            questionNumber="104.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="PensionOverlays"
            labelText="A 'pension savings overlay'?"
            note="Some Dutch systems have this option. The additional contributions are converted into an annuity at retirement. Interest is based on a fixed percentage or on the performance of the pension fund."
            subQuestion
          />
          <SurveyElement
            questionNumber="104.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_274"
            labelText="To change their contribution rate in order to get either more money at retirement or earlier eligibility to retire?"
            note="For example, some of the Australian DB plans permit the employee to contribute at a higher rate causing benefits to accrue more quickly so the member's defined benefit at retirement will be greater."
            subQuestion
          />
          <SurveyElement
            questionNumber="105"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_282b"
            labelText="Do you have a Highly Compensated Employee replacement benefit program for employees that exceed legal or contractual limits of maximum pensionable earnings?"
            subQuestion
          />
          <SurveyElement
            questionNumber="106"
            labelText="Are any of the following activities administered by a third party:"
          />
          <SurveyElement
            questionNumber="106.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="DBOutsourced"
            labelText="DB administration?"
            subQuestion
          />
          <SurveyElement
            questionNumber="106.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="DCOutsourced"
            labelText="DC administration?"
            subQuestion
          />
          <SurveyElement
            questionNumber="106.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="PensionerDataOutsourced"
            labelText="Pensioner data maintenance?"
            subQuestion
          />
          <SurveyElement
            questionNumber="106.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="ActiveMemberOutsourced"
            labelText="Active member data maintenance?"
            subQuestion
          />
          <SurveyElement
            questionNumber="106.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="CollectionsOutsourced"
            labelText="Contribution collection?"
            subQuestion
          />
          <SurveyElement
            questionNumber="106.f"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="DisabilityOutsourced"
            labelText="Disability decisions?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107"
            labelText="Which of the following programs do you offer to members AND administer yourself:"
            note="i.e., design, enrolment, premium collection"
          />
          <SurveyElement
            questionNumber="107.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216b"
            labelText="Pre-retirement health?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216c"
            labelText="Post-retirement health?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216d"
            labelText="Pre-retirement dental and vision?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216e"
            labelText="Post-retirement dental and vision?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216f"
            labelText="Long-term care insurance?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.f"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216h"
            labelText="Loans to members?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.g"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216i"
            labelText="Optional tax deferred savings plans?"
            note="i.e., 457, 403, 401k, 401a, etc?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.h"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216m"
            labelText="Optional insurance?"
            note="i.e., life and/or auto and/or home?"
            subQuestion
          />
          <SurveyElement
            questionNumber="107.i"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_216n"
            labelText="Other (describe)?"
            subQuestion
          />
          <SurveyConditionalSegment 
            showIf={{Q_216n: {not: CommonResponses.NO}}}
          >
            <SurveyElement
              questionNumber="107.i.i1"
              inputType={ElementType.TEXTAREA}
              name="Q_216nDescr"
              labelText="Describe other program:"
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber="107.i.i2"
              inputType={ElementType.TEXTAREA}
              name="Q_216oDescr"
              labelText="Describe another program (if any):"
              doubleSubQuestion
            />
            <SurveyElement
              questionNumber="107.i.i3"
              inputType={ElementType.TEXTAREA}
              name="Q_216pDescr"
              labelText="Describe another program (if any):"
              doubleSubQuestion
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="108"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_222"
            labelText="Is your organization directly responsible for both investments and pension administration?"
            subQuestion
          />
          <SurveyElement
            questionNumber="109"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="OrgStructure2"
            labelText="Does your board have an organization separate from the plan administrator that supports the Board and helps oversee the administrator?"
            note="This separate organization may also be responsible for public relations and select administrative duties and projects such as designing communication materials."
            subQuestion
          />
          <SurveyElement
            questionNumber="110"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_221"
            labelText="Does your board have the power on its own to approve your operating budget?"
            note="i.e. your budget does not also have to be approved by a separate government representative, such as the Treasury, Legislature, Governor, Minister, General Assembly, etc."
            subQuestion
          />
        </SurveySection>
        <SurveySection
          id="2"
          labelText="Paying Pension Rules"
        >
          <SurveyElement
            questionNumber="111"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_303YN"
            labelText="Do you make payments to annuitants that are accounted for separately from the normal pension?"
            note="For example : <ul> <li> Some systems permit employers to supplement the normal pension of their retirees. The pension fund collects the supplement from the employer and pays it on behalf of the employer.</li> <li> At some Dutch systems contributions to the normal retirement pension are required by the pensioner during early retirement. These contributions are often reimbursed to the pensioner. The accounting and the member's payment advice shows 2 different payments (the pension + the reimbursement) and 1 collection (the required contribution).</li> </ul>"
            subQuestion
          />
          <SurveyElement
            questionNumber="112"
            labelText="Do you:"
          />
          <SurveyElement
            questionNumber="112.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_243bYN"
            labelText="Check income of non-disabled pensioners?"
            note="For most systems this does not apply. At a few systems, if a pensioner's income from other sources exceeds a certain amount, his/her pension could be stopped or reduced."
            subQuestion
          />
          <SurveyElement
            questionNumber="112.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_310"
            labelText="Check income of disabled members after they have started receiving disability payments?"
            subQuestion
          />
          <SurveyElement
            questionNumber="112.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="CheckingOfSchoolCertificatesYN"
            labelText="Check school status?"
            note="For example, some systems will check that a dependent beneficiary is still eligible to receive a survivor pension benefit."
            subQuestion
          />
          <SurveyElement
            questionNumber="112.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="ProofOfLifeYN"
            labelText="Do proof-of-life checks that require individual annuitants to provide affidavits or notarization or similar proof of life?"
            subQuestion
          />
          <SurveyElement
            questionNumber="112.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="VolIncomeConfirmationYn"
            labelText="Provide written confirmations of pensioner income or member account balances to third-parties?"
            note="For example, provide confirmation of income or account value for loans or for social security or subsidized housing, etc."
            subQuestion
          />
        </SurveySection>
        <SurveySection
          id="3"
          labelText="Payment Options"
        >
          <SurveyElement
            questionNumber="113"
            labelText="Do you offer joint and survivor options that are:"
          />
          <SurveyElement
            questionNumber="113.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_236b"
            labelText="Reduced to Beneficiary Only?"
            note="For example, If the beneficiary dies first, then the retiree's pension continues at the same level. However if the retiree dies first then the beneficiary receives a reduced pension (such as 70% for spouse)."
            subQuestion
          />
          <SurveyElement
            questionNumber="113.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_236a"
            labelText="Reduced to Last Survivor?"
            note="For example, if either the retiree or beneficiary dies the survivor receives a reduced pension (such as 70%, etc.)."
            subQuestion
          />
          <SurveyElement
            questionNumber="113.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_236c"
            labelText="Reversion or Pop-up?"
            note="For example, if the beneficiary dies first, the retiree's pension increases to an unmodified level. However, if the retiree dies first the pension does not increase for the surviving beneficiary (and it may decrease)."
            subQuestion
          />
          <SurveyElement
            questionNumber="114"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="SurvivorPctLimitYN"
            labelText="Do you limit the number of Joint and Beneficiary or Survivor percentages (i.e., 100% Survivor, 50% Survivor, etc.)? If you permit an unlimited number of percentages, then your response should be no."
          />
          <SurveyConditionalSegment
            showIf={{
              SurvivorPctLimitYN: [CommonResponses.BLANK, CommonResponses.YES]
            }}
          >
            <SurveyElement
              questionNumber="114.a"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="# or unlimited"
              name="SurvivorPctLimit"
              labelText="How many percentages do you permit?"
              subQuestion
              allowUnknown
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="115"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_232"
            labelText="Do any of your retirement formula for members explicitly subtract estimated Social Security (or CPP in Canada) when determining the benefit?"
          />
          <SurveyConditionalSegment
            showIf={{
              Q_232: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="115.a"
              inputType={ElementType.SELECT}
              options={SelectCombos.ALL_SOME}
              name="Q_232a"
              labelText="Is this true for all of your members or are some pensions reduced to reflect Social Security and others not?"
              subQuestion
            />
            <SurveyElement
              questionNumber="115.b"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="Q_238"
              labelText="Do you have a Level Income option for early retirees that pays a higher benefit to members prior to age 65 and then reduces the benefit at age 65 when social security (or CPP in Canada) starts to be paid?"
              subQuestion
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="116"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_239"
            labelText="Do you have High/ Low or Low/ High options that are not tied to social security?"
            note="For example, a retiree might want higher payments for 10 years until a mortgage obligation is repaid, followed by lower payments."
          />
          <SurveyElement
            questionNumber="117"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_240"
            labelText="Do you offer Annuity Certain options?"
            note="For example, Annuity Certain options provide the annuitant with a monthly benefit for life. If the annuitant dies before a set guarantee period, monthly benefits continue to be paid to a beneficiary for the balance of the guarantee period."
          />
          <SurveyElement
            questionNumber="118"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_242"
            labelText="Do you have a designer option where members can design virtually any actuarially sound cash flow they choose?"
            note="Designer options need to be custom priced by an actuary."
          />
          <SurveyElement
            questionNumber="119"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_241"
            labelText="Can a member choose between a COLA protected and a non-COLA pension?"
            note="The only example we have seen provides a much higher FAS salary base for the non-COLA pension."
          />
          <SurveyElement
            questionNumber="120"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Backdrop"
            labelText="Do you have a Deferred Retirement Option Plan (DROP)?"
            note="This option allows eligible employees to receive payment of retirement benefits while continuing to work. These payments are usually deposited into a separate account, and the total accumulated value of this account is paid via lump sum to the employee on actual retirement."
          />
          <SurveyElement
            questionNumber="121"
            labelText="At retirement, can a member convert:"
          />
          <SurveyElement
            questionNumber="121.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="RetirementPaymentOptionsPartial"
            labelText="Part of his benefit into a partial lump sum payment?"
            subQuestion
          />
          <SurveyElement
            questionNumber="121.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="RetirementPaymentOptionsLumpSum"
            labelText="All of his benefit into a lump sum or commuted value payment?"
            note="That can be rolled over to another fund, or investment account, etc."
            subQuestion
          />
          <SurveyElement
            questionNumber="122"
            inputType={ElementType.SELECT}
            options={SelectCombosPABS.ANY_SET_DAYS}
            saveAsKey={true}
            name="Q_113"
            labelText="Are members permitted to retire mid-month (in which case they receive a partial pension payment for the remainder of the month) or are they always assumed to retire on a set day (usually the first or the last day) of the month?"
          />
          <SurveyElement
            questionNumber="123"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_233a"
            labelText="How many mortality tables do you keep track of for determining joint and survivor or beneficiary options?"
            note="Most systems track only one table. But some systems calculate joint and survivor pensions using the mortality table that was in effect when the retiring member joined the system. Since mortality tables change from time to time, the result is that these systems are required to track numerous mortality tables."
          />
        </SurveySection>
        <SurveySection
          id="4"
          labelText="Cost of Living"
        >
          <SurveyElement
            questionNumber="124"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_254"
            labelText="How many different cost of living adjustment (COLA) rule sets do you have for retired, and if applicable, inactive members? (These rule sets may be either contractual or legislated.)"
            note="Most systems have only one or none.  Examples of different COLA rule sets that could apply to various member groups or grandfathered subsets of member groups include:</br>1. CPI uncapped</br>2. CPI capped at 2% without a carry forward;</br>3. CPI capped at 2% with a carry forward"
          />
          <SurveyElement
            questionNumber="125"
            labelText="Do you have:"
          />
          <SurveyElement
            questionNumber="125.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_257"
            labelText="Cost of living adjustment (COLA) clauses that carry forward inflation that exceeds a cap (versus no cap or no carry forward or no COLA etc.)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="125.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_264YN"
            labelText="Conditional COLA based on the level of funding?"
            subQuestion
          />
          <SurveyElement
            questionNumber="125.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_255"
            labelText="Umbrella legislation that guarantees the purchasing power of an annuitants' pension will not fall below a certain level?"
            note="An example of such legislated protection is the PPPA in California."
            subQuestion
          />
          <SurveyElement
            questionNumber="126"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_258"
            labelText="Do you have COLA clauses that increase the base pensionable earnings of inactive members?"
          />
          <SurveyConditionalSegment
            showIf={{
              Q_258: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="126.a"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="Q_258a"
              labelText="Are these COLA increases the same as they are for annuitants?"
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection
          id="5"
          labelText="Benefit Formulas"
        >
          <SurveyElement
            questionNumber="127"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_228"
            labelText="How many different rule sets do you have that apply to member groups or subsets of a member group for qualifying for an unreduced retirement formula?"
            note="For example, one system has the following 3 rule sets that apply to its member groups and special subsets of its member groups. <br/>1. All public employees can get an unreduced retirement at 65 with 5 years of service, or at 60 with 20 years of service. (Even though there are two qualifying rules, it only counts as 1 rule set because the rules apply equally to all members.) <br/> 2. Pre-1995 public employees can get an unreduced retirement at age 55 with 20 years of service.  <br/>3. Teachers can get an unreduced retirement when age plus years of service equals 75."
          />
          <SurveyElement
            questionNumber="128"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_229"
            labelText="Can members retire earlier than the age required for an unreduced retirement formula?"
            note="For example, at one system an unreduced formula of 1.5% per year of service is available beginning at age 60. Members can retire earlier but the pension is reduced by 5% for each year earlier than age 60."
          />
          <SurveyElement
            questionNumber="129"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_230"
            labelText="How many different salary definitions could apply in retirement formula calculations?"
            note="Examples of different salary definitions include:</br>- Average of 3 final years' salary subject to raises not in excess of 10%;</br>- Average of 3 best consecutive years' salary with no cap on raises;</br>- Final 12 months salary."
          />
          <SurveyElement
            questionNumber="130"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_231"
            labelText="How many different 'formula percentage' rule sets could apply in unreduced retirement formulas?"
            note="For example, one system has the following three different 'formula percentage' rule sets:</br>1. Fire and Police get 2.5% per year of service;</br>2. Public Employees get 1.75% per year of service;</br>3. Teachers get 1.8% for the first 5 years of service, 2.0% for the next 5 years of service and 2.3% per year of service thereafter."
          />
          <SurveyElement
            questionNumber="131"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="DoYouHaveMore"
            labelText="Do you have different employers with different benefit formula? If yes, which of the following happens when a member moves from one employer that you administer to another with a different benefit formula:"
            note="For example, moves from PERS to Law Enforcement."
          />
          <SurveyConditionalSegment
            showIf={{
              DoYouHaveMore: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="131.a"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="Q_234b2"
              labelText="Each system uses its own formula and salary data to determine the benefit."
              subQuestion
            />
            <SurveyElement
              questionNumber="131.b"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="Q_234b1"
              labelText="Each system applies its own formula but uses either the salary earned in the last system, or the highest salary (or salaries) in either system."
              subQuestion
            />
            <SurveyElement
              questionNumber="131.c"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="HighestFormula"
              labelText="The highest formula will apply"
              subQuestion
            />
            <SurveyElement
              questionNumber="131.d"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="Q_234a"
              labelText="The formula of the plan where the member works last will apply."
              subQuestion
            />
            <SurveyElement
              questionNumber="131.e"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              name="Q_234c"
              labelText="Other (describe)?"
              subQuestion
            />
            <SurveyElement
              questionNumber="131.e.e1"
              inputType={ElementType.TEXTAREA}
              name="Q_234cDescr"
              showIf={{Q_234c: {not: CommonResponses.NO}}}
              doubleSubQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection
          id="6"
          labelText="External Reciprocity"
        >
          <SurveyElement
            questionNumber="132"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_252"
            labelText="Do you have agreements with external systems where you both agree to use the member's final salary from the system where the member worked immediately prior to retirement in the benefit calculation?"
            note="Otherwise, each system pays the dual member a pension benefit based on its own rules for determining the benefit. Neither credit nor money are transferred between systems."
          />
          <SurveyElement
            questionNumber="133"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_253"
            labelText="Do you have agreements with external Systems where the member may combine internal and external credit to form one joint account?"
            note="The accounts remain separate until the member applies for a benefit, at which time either:</br>- The System with the most service credit for that person is responsible for the combined account, or</br>- The System where the member worked last is responsible."
          />
        </SurveySection>
        <SurveySection
          id="7"
          labelText="Service Credit Rules"
        >
          <SurveyElement
            questionNumber="134"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_264"
            labelText="How many different definitions do you have for a full year of service credit?"
            note="For example, a system could have:</br>- One definition such as more than 120 days = a year.</br>- Or the following three definitions: 9 months = a year for state colleges, 10 months = a year for teachers and 12 months = a year for public employees.</br>- Or the following three definitions: 182 days in school district A or B, 179 days in school district C and 180 days in all other school districts.</br>- Or the following two definitions for hourly employees: 48 weeks of 40 hours per week versus 48 weeks of 36 hours per week."
          />
          <SurveyElement
            questionNumber="135"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_265"
            labelText="Does your system have more than one payroll year for determining service credit?"
            note="For example, the teachers' year could be July - June with their service credit determined based on the time worked July - June and the public employees' year could be January to December with their service credit determined based on time worked January to December."
          />
          <SurveyConditionalSegment
            showIf={{
              Q_265: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="135.a"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="# or n/a"
              name="Q_265a"
              labelText="How many different payroll years exist in your system?"
              subQuestion
              allowNA
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="136"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_266"
            labelText="How many different vesting periods do you have that apply to active members?"
            note="Your answer should be 0 if you have immediate vesting. Most North American systems have only one."
          />
          <SurveyElement
            questionNumber="137"
            labelText="Do you permit:"
          />
          <SurveyElement
            questionNumber="137.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_267a"
            labelText="Permanent part-time employees to be members?"
            note="An example of a permanent part-time employee is someone contracted to work 3 days a week."
            subQuestion
          />
          <SurveyElement
            questionNumber="137.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_267b"
            labelText="Casual/ temporary/ intermittent/ seasonal employees to be members?"
            note="An example of a 'temporary' employee is an infrequent substitute teacher."
            subQuestion
          />
          <SurveyElement
            questionNumber="138"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_268"
            labelText="Are you sometimes asked by employers to determine the eligibility of members?"
            note="This can occur when a member works for multiple employers in your system or when there is unclear eligibility legislation. For example, a school bus driver may drive buses for multiple districts or counties at the same time. Based on time spent within each district the driver would be ineligible. However, based on the combined employment the driver may be eligible."
          />
        </SurveySection>
        <SurveySection
          id="8"
          labelText="Service Credit Purchases"
        >
          <SurveyElement
            questionNumber="139"
            labelText="Indicate each of the payment methods you permit for service credit purchases and upgrades:"
          />
          <SurveyElement
            questionNumber="139.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_313d"
            labelText="Rollover from tax qualified plans such as 401(a) or 401(k) or Conduit IRA or KEOGH in the US; or RRSP plans in Canada?"
            subQuestion
          />
          <SurveyElement
            questionNumber="139.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_313a"
            labelText="Lump sum payments from members?"
            subQuestion
          />
          <SurveyElement
            questionNumber="139.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_313b"
            labelText="Installment payments direct from members?"
            subQuestion
          />
          <SurveyElement
            questionNumber="139.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_313c"
            labelText="Installment payments via payroll deduction through employers?"
            subQuestion
          />
          <SurveyElement
            questionNumber="140"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_314"
            labelText="How many different service credit purchase categories do you have with different definitions and/or eligibility requirements?"
            note="For example, some systems have multiple different categories with different definitions such as 'refunded prior service', 'sick leave', 'military service', etc. Other systems have a single category such as 'any previous work, any time, anywhere'."
            allowNA
          />
          <SurveyElement
            questionNumber="141"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_318"
            labelText="How many different service credit purchase calculation formula or methodologies do you have?"
            note="For example, one system has the following 4 different cost calculation formula:</br>- Previously refunded contributions X the actuarial earnings rate.</br>- Salary X Contribution Rate (no interest) for active duty military service.</br>- Salary X Contribution Rate  X  5% per annum for out-of-state government, or private school teaching service.</br>- Actuarial Cost for up to 5 years of any non-government, non-teaching work done outside of the pension system."
            allowNA
          />
          <SurveyElement
            questionNumber="142"
            labelText="Are your service credit purchase rules (category definitions, eligibility requirements and calculation methodologies):"
          />
          <SurveyElement
            questionNumber="142.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="PurchaseRulesIdentical"
            labelText="Essentially identical for all your members?"
            subQuestion
          />
          <SurveyElement
            questionNumber="142.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="PurchaseRulesSimilar"
            labelText="Similar for all member groups, albeit with some differences?"
            subQuestion
          />
          <SurveyElement
            questionNumber="142.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="PurchaseRulesDifferent"
            labelText="Very different for different member groups?"
            subQuestion
          />
        </SurveySection>
        <SurveySection
          id="9"
          labelText="Refunds, Transfers-out and Terminating Payments"
        >
          <SurveyElement
            questionNumber="143"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_293New"
            labelText="Do you pay a one-time death payment when a member, retiree or the retiree's beneficiary dies (separate from the survivor pension)?"
          />
          <SurveyConditionalSegment
            showIf={{
              Q_293New: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="143.a"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL2}
              placeholder="#"
              name="Q_293"
              labelText="How many different one-time death payment rule sets do you have?"
              note="i.e., $5,000, $2,000 etc."
              subQuestion
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="144"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            name="Q_291"
            labelText="How many different refund formulas do you have?"
            note="For example, a few systems have different formulas for vested and non-vested members, or for different member groups."
            allowNA
          />
        </SurveySection>
        <SurveySection
          id="10"
          labelText="Disability"
        >
          <SurveyElement
            questionNumber="145"
            labelText="What happens to disabled members' benefits when they reach regular retirement age:"
          />
          <SurveyElement
            questionNumber="145.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_309a"
            labelText="No change (disabled member continues to receive the same disability payments. There are no new potential pension obligations.)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="145.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_309b"
            labelText="Disabled members receive the greater of their current disability benefit or service retirement based on their service credit earned to the date of disability?"
            note="i.e. time on disability does not count as service credit."
            subQuestion
          />
          <SurveyElement
            questionNumber="145.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_309c"
            labelText="Disabled members receive service retirement (time on disability counts as eligible service credit)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="145.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_309d"
            labelText="Other (describe)?"
            subQuestion
          />
          <SurveyConditionalSegment
            showIf={{
              Q_309d: [CommonResponses.BLANK, CommonResponses.YES]
            }}
          >
            <SurveyElement
              questionNumber="145.d.d1"
              inputType={ElementType.TEXTAREA}
              name="Q_309dDescr"
              doubleSubQuestion
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="146"
            labelText="Will you pay a disabled member that returns to work at a salary lower than he previously earned:"
          />
          <SurveyElement
            questionNumber="146.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_325YN"
            labelText="The difference between his old salary (or his old disability benefit) and his new lower salary?"
            subQuestion
          />
          <SurveyElement
            questionNumber="146.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_324YN"
            labelText="An amount that is potentially greater than the difference between his old salary and his new lower salary?"
            subQuestion
          />
          <SurveyElement
            questionNumber="147"
            labelText="How do you determine whether a member qualifies for long-term disability/ disability pension:"
          />
          <SurveyElement
            questionNumber="147.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_300a"
            labelText="Follow the ruling of a government agency such as social security or worker's compensation?"
            subQuestion
          />
          <SurveyElement
            questionNumber="147.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_SOME_NA}
            name="Q_300c"
            labelText="Employer decides?"
            subQuestion
          />
          <SurveyElement
            questionNumber="147.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_300d"
            labelText="Process independent of social security, worker's compensation and employer decisions?"
            note="For example, many systems use independent internal processes or medical review boards or medical consultants."
            subQuestion
          />
          <SurveyElement
            questionNumber="147.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_300e"
            labelText="Other (describe)?"
            subQuestion
          />
          <SurveyConditionalSegment
            showIf={{
              Q_300e: [CommonResponses.BLANK, CommonResponses.YES]
            }}
          >
            <SurveyElement
              questionNumber="147.d.d1"
              inputType={ElementType.TEXTAREA}
              name="Q_300eDescr"
              doubleSubQuestion
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="148"
            labelText="Which of the following descriptions best describes the MINIMUM level of disability necessary to be eligible for a long-term disability/ disability pension:"
            note="If you have different plans with different definitions, choose the definition that applies to the largest number of cases."
          />
          <SurveyElement
            questionNumber="148.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_304a"
            labelText="Disabling injury or illness that prevents you from performing your current job duties (even though you might be able to perform other jobs) and expected to be permanent (or for some systems - persist longer than 6 or 12 months)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="148.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_SOME_NA}
            name="Q_304b"
            labelText="Disabling injury or illness that prevents the member from performing current and 'other' jobs that he/she is qualified for and/or can become qualified to do in a reasonable period of time and expected to be permanent (or for some systems - persist longer than 6 or 12 months)?"
            note="Sometimes but not always the 'other job' is defined as not able to earn a certain level (i.e., 75%) of pre-disability earnings."
            subQuestion
          />
          <SurveyElement
            questionNumber="148.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_304c"
            labelText="Totally and permanently incapacitated and member is not reasonably expected to recover from disabling medical condition or not expected to ever work again?"
            subQuestion
          />
          <SurveyElement
            questionNumber="148.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_304d"
            labelText="Other (describe)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="148.d.d1"
            inputType={ElementType.TEXTAREA}
            name="Q_304dDescr"
            showIf={{Q_304d: [CommonResponses.BLANK, CommonResponses.YES]}}
            doubleSubQuestion
          />
          <SurveyElement
            questionNumber="149"
            labelText="If you administer short-term disability:"
          />
          <SurveyElement
            questionNumber="149.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_299a"
            labelText="Are the short-term and long-term disability/ disability pension processes closely entwined?"
            note="i.e., difficult to distinguish between costs of long-term/disability pensions and short term disability, same staff do both, similar approval processes."
            subQuestion
          />
          <SurveyElement
            questionNumber="149.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_299b"
            labelText="Are the disability definitions, other than the expected duration of disability, the same for both long-term and short-term disability?"
            note="For example, the only difference between the definition of long-term/ disability pensions and short-term disability at some systems is the disabling injury or illness is expected to last longer than 12 months for long-term."
            subQuestion
          />
          <SurveyElement
            questionNumber="149.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_299c"
            labelText="Are there materially different approval processes for short-term and long-term disability/ disability pensions?"
            subQuestion
          />
          <SurveyElement
            questionNumber="150"
            labelText="How many different rule sets with different definitions or benefits do you have that apply to member groups or subsets of a member group for:"
          />
          <SurveyElement
            questionNumber="150.a"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# or n/a"
            name="Q_301"
            labelText="Long-term disability/ disability pensions?"
            subQuestion
            allowNA
          />
          <SurveyElement
            questionNumber="150.b"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# or n/a"
            name="Q_301b"
            labelText="Short-term disability (if you administer it yourself)?"
            note="For example, some systems have different disability definitions or benefits for police and fire than they do for other public employees. Other systems have grandfathered disability rule sets that only apply to members hired prior to a certain date."
            subQuestion
            allowNA
          />
          <SurveyElement
            questionNumber="151"
            labelText="Do you reduce payments if the member qualifies or receives:"
          />
          <SurveyElement
            questionNumber="151.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_307a"
            labelText="Disability social security?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_SOME_NA}
            name="Q_307b"
            labelText="Worker's compensation?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_307c"
            labelText="Other public funds (e.g. federal military disability)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_307d"
            labelText="Income protection plans/other disability insurance?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_307e"
            labelText="Employer sick leave and annual leave pay?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.f"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_307f"
            labelText="Unemployment compensation?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.g"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_307g"
            labelText="Income from other employment?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.h"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_307h"
            labelText="Other (describe)?"
            subQuestion
          />
          <SurveyElement
            questionNumber="151.h.h1"
            inputType={ElementType.TEXTAREA}
            name="Q_307hDescr"
            showIf={{Q_307h: [CommonResponses.BLANK, CommonResponses.YES]}}
            doubleSubQuestion
          />
        </SurveySection>
        <SurveySection
          id="11"
          labelText="Pensionable Earnings"
        >
          <SurveyElement
            questionNumber="152"
            labelText="Indicate which of the following forms of variable compensation are paid in your system. And, if paid, indicate whether all, some or none of that type of variable compensation is included in pensionable earnings."
          />
          <SurveyElement
            inputType="grid"
            styleName={"dataTable pensionableEarnings"}
          >
            <SurveyGridHeader>
              <SurveyElement
                labelText=""
                inputType={ElementType.LABEL}
                name=""
              />
              <SurveyElement
                labelText="Is this paid in your system?"
                inputType={ElementType.LABEL}
              />
              <SurveyElement
                labelText="If yes, are all, some or none of it included in pensionable earnings?"
                inputType={ElementType.LABEL}
              />
            </SurveyGridHeader>
            <SurveyGridBody>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="152.a"
                  labelText="Bonuses?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_260"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_260: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.SELECT}
                    options={SelectCombos.ALL_SOME_NONE}
                    name="Q_260a"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="152.b"
                  labelText="Allowances, such as remote location pay or 'high risk' duty allowance or a car allowance?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_261"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_261: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.SELECT}
                    options={SelectCombos.ALL_SOME_NONE}
                    name="Q_261a"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="152.c"
                  labelText="Overtime pay?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_262"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_262: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.SELECT}
                    options={SelectCombos.ALL_SOME_NONE}
                    name="Q_262a"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="152.d"
                  labelText="Commissions or similar payments such as fees paid to sheriffs for process serving?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_263"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_263: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.SELECT}
                    options={SelectCombos.ALL_SOME_NONE}
                    name="Q_263a"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
            </SurveyGridBody>
          </SurveyElement>
          <SurveyElement
            questionNumber="153"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_259"
            labelText="When determining a member's pensionable earnings does a cap on salary increases apply?"
          />
        </SurveySection>
        <SurveySection
          id="12"
          labelText="Customization Options"
        >
          <SurveyElement
            questionNumber="154"
            labelText="Can either existing employers, or a new employer joining your system, choose:"
          />
          <SurveyElement
            questionNumber="154.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_248g"
            labelText="Whether they offer early retirement, or a window of early retirement?"
            subQuestion
          />
          <SurveyElement
            questionNumber="154.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_248c"
            labelText="Whether or not part-time employees are eligible?"
            subQuestion
          />
          <SurveyElement
            questionNumber="154.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_248d"
            labelText="Whether employee contributions are paid pre or post tax?"
            subQuestion
          />
          <SurveyElement
            questionNumber="154.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_248e"
            labelText="Whether they pay for employee contributions themselves, or not?"
            subQuestion
          />
          <SurveyElement
            questionNumber="154.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_248f"
            labelText="Position coverage based on predetermined rule sets?"
            note="For example, employers can choose from a list of pre-determined rules sets such as 1.5% X FAS for General and 2.5% X FAS for Law Enforcement. Employers may have flexibility to determine eligibility for each group."
            subQuestion
          />
          <SurveyElement
            questionNumber="154.f"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_248h"
            labelText="Contribution levels and/ or match rates?"
            note="For example, at Texas MRS, employers can choose employee deposit rates of 5%, 6% or 7% and employer match rates of 1 to 1, 1.5 to 1 or 2 to 1. We think this only applies to money match and DC plans because for DB plans the promised benefit determines the contribution."
            subQuestion
          />
          <SurveyElement
            questionNumber="154.g"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_251"
            labelText="To pay for one-time improvements in retiree or member benefits?"
            note="For example, one fund's employers can elect to pay to improve the money purchase entitlement of their members."
            subQuestion
          />
          <SurveyElement
            questionNumber="155"
            labelText="When new employers join your system, do they have the flexibility to customize any of the following items: If yes, indicate the number of standard choices for that item."
          />
          <SurveyElement
            inputType="grid"
            styleName={"dataTable customizationOptions"}
          >
            <SurveyGridHeader>
              <SurveyElement
                labelText=""
                inputType={ElementType.LABEL}
                name=""
              />
              <SurveyElement
                labelText="Can they customize?"
                inputType={ElementType.LABEL}
              />
              <SurveyElement
                labelText="If yes: # of standard options"
                inputType={ElementType.LABEL}
              />
            </SurveyGridHeader>
            <SurveyGridBody>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.a"
                  labelText="Benefit program multipliers?"
                  inputType={ElementType.LABEL}
                  name=""
                  note="i.e., 2% per year of service, 2.5% per year of service, etc."
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO_NA}
                  name="Q_249aYN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249aYN: [CommonResponses.BLANK, CommonResponses.YES]
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249a"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.b"
                  labelText="Final salary definition?"
                  inputType={ElementType.LABEL}
                  name=""
                  note="i.e., Sick Leave in or out, Final 1 year, Highest 5 consecutive years, etc."
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO_NA}
                  name="Q_249bYN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249bYN: [CommonResponses.BLANK, CommonResponses.YES]
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249b"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.c"
                  labelText="Retirement eligibility rules?"
                  inputType={ElementType.LABEL}
                  name=""
                  note="i.e., age and/or years of service required to retire"
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249cYN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249cYN: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249c"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.d"
                  labelText="Cost of living adjustment rules?"
                  inputType={ElementType.LABEL}
                  name=""
                  note="i.e., CPI capped at 2%, CPI uncapped, etc"
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249dYN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249dYN: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249d"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.e"
                  labelText="Vesting period?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249eYN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249eYN: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249e"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.f"
                  labelText="Service credit purchase categories?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249fYN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249fYN: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249f"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.g"
                  labelText="Death benefit coverage?"
                  inputType={ElementType.LABEL}
                  name=""
                  note="i.e., one system has 3 choices: none, $5,000 and $10,000"
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249gYN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249gYN: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249g"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.h"
                  labelText="Disability coverage rules?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249g2YN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249g2YN: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249g2"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.i"
                  labelText="Choice as to whether and how contributions and benefits are coordinated with social security?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249g3YN"
                  pageName="PlanDesign"
                />
                <SurveyConditionalSegment
                  showIf={{
                    Q_249g3YN: { not: CommonResponses.NO }
                  }}
                >
                  <SurveyElement
                    inputType={ElementType.NUMBER}
                    format={NumberFormat.INTEGER}
                    placeholder="#"
                    name="Q_249g3"
                    pageName="PlanDesign"
                  />
                </SurveyConditionalSegment>
              </SurveyGridRow>
              <SurveyGridRow>
                <SurveyElement
                  questionNumber="155.j"
                  labelText="Other (describe)?"
                  inputType={ElementType.LABEL}
                  name=""
                />
                <SurveyElement
                  inputType={ElementType.SELECT}
                  options={SelectCombos.YES_NO}
                  name="Q_249hYN"
                  pageName="PlanDesign"
                />
                <SurveyElement
                  inputType={ElementType.NUMBER}
                  format={NumberFormat.INTEGER}
                  placeholder="#"
                  name="Q_249h"
                  pageName="PlanDesign"
                  showIf={{Q_249hYN: {not: CommonResponses.NO}}}
                />
              </SurveyGridRow>
              <SurveyElement
                inputType={ElementType.TEXTAREA}
                name="Q_249hDescr"
                pageName="PlanDesign"
                showIf={{Q_249hYN: {not: CommonResponses.NO}}}
              />
            </SurveyGridBody>
          </SurveyElement>
          <SurveyElement
            questionNumber="156"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_250"
            labelText="Can an existing employer change any of the choices (per the question above), effectively creating a new or altered rule set, at any time?"
          />
        </SurveySection>
        <SurveySection
          id="13"
          labelText="Collections and Data Maintenance"
        >
          <SurveyElement
            questionNumber="157"
            labelText="How many different contribution percentages do you collect from:"
          />
          <SurveyElement
            questionNumber="157.a"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="Q_273a"
            labelText="Employers?"
            note="For example, single member group systems may have only one contribution percentage whereas some multi-plan systems may collect numerous different contribution rates from various participating employers."
            subQuestion
          />
          <SurveyElement
            questionNumber="157.b"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name="Q_273b"
            labelText="Members?"
            subQuestion
          />
          <SurveyElement
            questionNumber="158"
            labelText="Which of the following payment methods for employee contributions occur in the plans that you administer:"
          />
          <SurveyElement
            questionNumber="158.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_275a"
            labelText="No employee contributions?"
            subQuestion
          />
          <SurveyElement
            questionNumber="158.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_275b"
            labelText="Employer pays his part and also the employee contributions?"
            subQuestion
          />
          <SurveyElement
            questionNumber="158.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_275c"
            labelText="Employer withholds employee contributions pre-tax from his salary?"
            subQuestion
          />
          <SurveyElement
            questionNumber="158.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_275d"
            labelText="Employer withholds employee contributions post-tax from his salary?"
            subQuestion
          />
          <SurveyElement
            questionNumber="159"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_276"
            labelText="Do you have any other contributions in addition to the regular employee and employer contributions?"
            note="For example, Ohio SERS collects a surcharge for members who earn less than a minimum compensation amount."
          />
          <SurveyElement
            questionNumber="159.a"
            labelText="If yes, describe:"
            inputType={ElementType.TEXTAREA}
            name="Q_276aDescr"
            showIf={{Q_276: {not: CommonResponses.NO}}}
            subQuestion
          />
          <SurveyElement
            questionNumber="160"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_299pre"
            labelText="Do you collect pension contributions from any members directly?"
            note="For example, Nurses in the Netherlands can continue to contribute to their pension even if they are inactive. Do not include optional contributions such as to 401k savings plans"
          />
          <SurveyElement
            questionNumber="161"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="ChangingDBOptions"
            labelText="Do members deal with you directly when selecting or changing DB plan options such as options to switch from core DB to DC or DROP plans, option to participate in variable investment option overlays, option to change their contribution rate, option to repair pension gaps, pre-retirement election options, etc?"
          />
          <SurveyElement
            questionNumber="162"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="SeekInactives"
            labelText="Are you required, by policy or by law, to actively seek out and initiate either a benefit or a refund for inactive vested members or inactive unvested members?"
          />
        </SurveySection>
        <SurveySection
          id="14"
          labelText="Billing and Inspection"
        >
          <SurveyElement
            questionNumber="163"
            labelText="Do you:"
          />
          <SurveyElement
            questionNumber="163.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="Q_301YN"
            labelText="Send a written advice to employers that inform them of their required contribution rates and then rely on each employer to pay the correct contributions?"
            subQuestion
          />
          <SurveyElement
            questionNumber="163.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="InvoiceInArrears"
            labelText="Invoice employers in arrears based on actual member service and salary data?"
            subQuestion
          />
          <SurveyElement
            questionNumber="163.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_NA}
            name="InvoiceInAdvanceAndAdjust"
            labelText="Invoice employers in advance based on estimated member service and salary data, and then adjust based on actual experience?"
            subQuestion
          />
          <SurveyElement
            questionNumber="164"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# or n/a"
            name="FrequencyInvoices"
            labelText="How many times per year do you send invoices or 'advices' to each employer?"
            allowNA
          />
        </SurveySection>
        <SurveySection
          id="15"
          labelText="Divorce"
        >
          <SurveyElement
            questionNumber="165"
            labelText="Choose the statement that best describes how divorce settlements for active members (or divorce decrees or QDROS, or QILDROS, or Division of Benefit Orders, etc.) impact your system. If you have different rules for different plans, choose the statement that applies to the largest number of cases."
          />
          <SurveyElement
            questionNumber="165.a"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_295a"
            labelText="Minimal impact. Law prevents you from paying the pension to anybody except the member and the member's specified beneficiaries."
            subQuestion
          />
          <SurveyElement
            questionNumber="165.b"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_SOME}
            name="Q_295b"
            labelText="Minimal impact unless children are involved. With children you may be required to redirect payment."
            subQuestion
          />
          <SurveyElement
            questionNumber="165.c"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_295c"
            labelText="A portion of the pension is paid to the ex-spouse, but ONLY when the member begins receiving benefits."
            subQuestion
          />
          <SurveyElement
            questionNumber="165.d"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_295d"
            labelText="A portion of the pension is paid to the ex-spouse. The ex-spouse can initiate the pension at a time different than the member provided that eligibility conditions are met."
            subQuestion
          />
          <SurveyElement
            questionNumber="165.e"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            name="Q_295f"
            labelText="Other (describe)."
            subQuestion
          />
          <SurveyElement
            questionNumber="165.e.e1"
            inputType={ElementType.TEXTAREA}
            name="Q_295fDescr"
            showIf={{Q_295f: {not: CommonResponses.NO}}}
            doubleSubQuestion
          />
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  );
}